/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from "react";
import AppProvider from "./src/context/AppProvider";

import "normalize.css";
import "./src/styles/fonts.scss";
import "./src/styles/base.scss";
import "./src/styles/transitions.scss";

export const onInitialClientRender = () => {
    window.___APP_INITIAL_RENDER_COMPLETE = true
}

export const wrapRootElement = ({ element }) => (
    <AppProvider>
        {element}
    </AppProvider>
)

export const onClientEntry = async () => {
    if (typeof IntersectionObserver === `undefined`) {
      await import(`intersection-observer`);
    }
    
    function setHeight(){
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    setHeight();

    window.addEventListener( 'resize', () => {
        setTimeout( setHeight, 100 );
    });
}